module.exports = __webpack_public_path__ + "img/strom2.ab0e6ffd.png";